import app from './app.json';
import courseTsume from './courseTsume.json';
import specialTraining from './specialTraining.json';
import courseTitle from './courseTitle.json';
import coursePlanTitle from './coursePlanTitle.json';
import matchResult from './matchResult.json';
import reviewGameComment from './reviewGameComment.json';

export default {
  ...app,
  ...courseTsume,
  ...specialTraining,
  ...courseTitle,
  ...coursePlanTitle,
  ...matchResult,
  ...reviewGameComment,
};
